<template>
    <v-app>            
          <div class="container">
            <div class="row text-center" >
              <!-- Ligne 2-->
              <div class="col-md-1">       
                  <v-btn icon elevation="20"
                  medium v-if="play"  v-on:click="clikPause">
                    <v-icon>mdi-pause</v-icon>
                  </v-btn>            
                  <v-btn icon elevation="20"
                  medium v-if="pause" v-on:click="clikPlay">
                    <v-icon>mdi-play</v-icon>
                  </v-btn>
              </div>
              <div class="col-md-2">
                  <v-btn v-if="play"  icon elevation="10"
                  medium :color="color2"
                  v-on:click="change(2)"
                  >
                    <span class="vitesse font-weight-bold">x0.25</span>
                  </v-btn>
                  <v-btn v-if="play" icon elevation="10"
                  medium :color="color15"
                  v-on:click="change(1.5)"
                  >
                    <span class="vitesse font-weight-bold">x0.5</span>
                  </v-btn>
                  <v-btn v-if="play" icon elevation="10"
                  medium :color="color1"
                  v-on:click="change(1)"
                  >
                    <span class="vitesse font-weight-bold">x1</span>
                  </v-btn>
                  <v-btn v-if="play" icon elevation="10"
                  medium :color="color05"
                  v-on:click="change(0.5)"
                  >
                    <span class="vitesse font-weight-bold">x2</span>
                  </v-btn> 
              </div> 
              <div class="col-md-9">
                <v-pagination circle v-model="page" :length="taille"></v-pagination>
              </div>
              <!-- Ligne 3-->
              <div class="col-md-4">
                <div class="subheading titreColorImg">
                  <span v-text="items[(page*3)-3].caption"> </span>
                  <span class="pull-right">
                    <button v-on:click="clikPause" type="button" data-toggle="modal" data-target="#testImg1">
                    <svg width="22" height="22" viewBox="0 0 25 25" class="subheading" fill="orange"
                  xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.587,0.057l6.529,0.621c0,0,0.869-0.027,0.383,0.457C7.011,1.624,5.833,2.801,5.833,2.801
                        S6.12,3.09,6.563,3.526c1.254,1.258,3.539,3.543,4.469,4.473c0,0,0.318,0.189-0.064,0.57c-0.383,0.387-2.072,2.068-2.346,2.344
                        c-0.268,0.273-0.475,0.057-0.475,0.057c-0.904-0.904-3.27-3.266-4.484-4.482C3.271,6.092,3.015,5.835,3.015,5.835
                        S2.067,6.78,1.474,7.374c-0.59,0.592-0.588-0.299-0.588-0.299S0.062,1.225,0.062,0.52C0.062,0.016,0.587,0.057,0.587,0.057z"/>
                      <path d="M23.122,23.608l-6.523-0.621c0,0-0.871,0.025-0.387-0.461c0.486-0.484,1.666-1.666,1.666-1.666
                        s-0.287-0.285-0.727-0.723c-1.256-1.26-3.541-3.543-4.471-4.479c0,0-0.322-0.18,0.062-0.564s2.07-2.07,2.346-2.344
                        c0.271-0.275,0.477-0.059,0.477-0.059c0.902,0.906,3.27,3.27,4.482,4.482c0.393,0.395,0.65,0.654,0.65,0.654
                        s0.949-0.947,1.541-1.541c0.59-0.592,0.59,0.301,0.59,0.301s0.822,5.854,0.822,6.549C23.651,23.647,23.122,23.608,23.122,23.608z"
                        />
                      <path d="M0.001,23.094l0.615-6.531c0,0-0.023-0.869,0.465-0.383c0.484,0.486,1.664,1.668,1.664,1.668
                        S3.03,17.561,3.47,17.12c1.256-1.256,3.541-3.541,4.475-4.475c0,0,0.184-0.316,0.568,0.066c0.383,0.387,2.07,2.072,2.344,2.346
                        c0.273,0.271,0.055,0.477,0.055,0.477c-0.906,0.904-3.266,3.27-4.48,4.486c-0.395,0.393-0.652,0.648-0.652,0.648
                        s0.945,0.947,1.537,1.537c0.592,0.594-0.297,0.59-0.297,0.59s-5.85,0.824-6.551,0.824C-0.042,23.62,0.001,23.094,0.001,23.094z"/>
                      <path d="M23.552,0.557l-0.615,6.529c0,0,0.023,0.869-0.461,0.383c-0.49-0.49-1.668-1.664-1.668-1.664
                        s-0.286,0.286-0.725,0.725c-1.256,1.256-3.543,3.541-4.475,4.473c0,0-0.184,0.318-0.568-0.066s-2.068-2.066-2.346-2.34
                        c-0.27-0.279-0.057-0.482-0.057-0.482c0.906-0.904,3.27-3.268,4.484-4.48c0.396-0.395,0.65-0.652,0.65-0.652
                        s-0.943-0.945-1.537-1.539c-0.592-0.592,0.299-0.586,0.299-0.586s5.849-0.828,6.552-0.828C23.595,0.03,23.552,0.557,23.552,0.557z"
                        />
                    </svg>
                  </button>
                  </span>
                </div>
                <v-img contain max-height="heighttest" v-bind:lazy-src="items[(page*3)-3].src" v-bind:src="items[(page*3)-3].src"></v-img>
              </div>
              <div class="col-md-4">
                <div class="subheading titreColorImg">
                  <span v-text="items[(page*3)-2].caption"> </span>
                  <span class="pull-right">
                    <button v-on:click="clikPause" type="button" data-toggle="modal" data-target="#testImg2">
                    <svg width="22" height="22" viewBox="0 0 25 25" class="subheading" fill="orange"
                  xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.587,0.057l6.529,0.621c0,0,0.869-0.027,0.383,0.457C7.011,1.624,5.833,2.801,5.833,2.801
                        S6.12,3.09,6.563,3.526c1.254,1.258,3.539,3.543,4.469,4.473c0,0,0.318,0.189-0.064,0.57c-0.383,0.387-2.072,2.068-2.346,2.344
                        c-0.268,0.273-0.475,0.057-0.475,0.057c-0.904-0.904-3.27-3.266-4.484-4.482C3.271,6.092,3.015,5.835,3.015,5.835
                        S2.067,6.78,1.474,7.374c-0.59,0.592-0.588-0.299-0.588-0.299S0.062,1.225,0.062,0.52C0.062,0.016,0.587,0.057,0.587,0.057z"/>
                      <path d="M23.122,23.608l-6.523-0.621c0,0-0.871,0.025-0.387-0.461c0.486-0.484,1.666-1.666,1.666-1.666
                        s-0.287-0.285-0.727-0.723c-1.256-1.26-3.541-3.543-4.471-4.479c0,0-0.322-0.18,0.062-0.564s2.07-2.07,2.346-2.344
                        c0.271-0.275,0.477-0.059,0.477-0.059c0.902,0.906,3.27,3.27,4.482,4.482c0.393,0.395,0.65,0.654,0.65,0.654
                        s0.949-0.947,1.541-1.541c0.59-0.592,0.59,0.301,0.59,0.301s0.822,5.854,0.822,6.549C23.651,23.647,23.122,23.608,23.122,23.608z"
                        />
                      <path d="M0.001,23.094l0.615-6.531c0,0-0.023-0.869,0.465-0.383c0.484,0.486,1.664,1.668,1.664,1.668
                        S3.03,17.561,3.47,17.12c1.256-1.256,3.541-3.541,4.475-4.475c0,0,0.184-0.316,0.568,0.066c0.383,0.387,2.07,2.072,2.344,2.346
                        c0.273,0.271,0.055,0.477,0.055,0.477c-0.906,0.904-3.266,3.27-4.48,4.486c-0.395,0.393-0.652,0.648-0.652,0.648
                        s0.945,0.947,1.537,1.537c0.592,0.594-0.297,0.59-0.297,0.59s-5.85,0.824-6.551,0.824C-0.042,23.62,0.001,23.094,0.001,23.094z"/>
                      <path d="M23.552,0.557l-0.615,6.529c0,0,0.023,0.869-0.461,0.383c-0.49-0.49-1.668-1.664-1.668-1.664
                        s-0.286,0.286-0.725,0.725c-1.256,1.256-3.543,3.541-4.475,4.473c0,0-0.184,0.318-0.568-0.066s-2.068-2.066-2.346-2.34
                        c-0.27-0.279-0.057-0.482-0.057-0.482c0.906-0.904,3.27-3.268,4.484-4.48c0.396-0.395,0.65-0.652,0.65-0.652
                        s-0.943-0.945-1.537-1.539c-0.592-0.592,0.299-0.586,0.299-0.586s5.849-0.828,6.552-0.828C23.595,0.03,23.552,0.557,23.552,0.557z"
                        />
                    </svg>
                    </button>
                  </span>
                </div>
                <v-img contain max-height="heighttest" v-bind:lazy-src="items[(page*3)-2].src" v-bind:src="items[(page*3)-2].src"></v-img>
              </div>
              <div class="col-md-4">
                <div class="subheading titreColorImg">
                  <span v-text="items[(page*3)-1].caption"> </span>
                  <span class="pull-right">
                    <button v-on:click="clikPause" type="button" data-toggle="modal" data-target="#testImg3">
                    <svg width="22" height="22" viewBox="0 0 25 25" class="subheading" fill="orange"
                  xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.587,0.057l6.529,0.621c0,0,0.869-0.027,0.383,0.457C7.011,1.624,5.833,2.801,5.833,2.801
                        S6.12,3.09,6.563,3.526c1.254,1.258,3.539,3.543,4.469,4.473c0,0,0.318,0.189-0.064,0.57c-0.383,0.387-2.072,2.068-2.346,2.344
                        c-0.268,0.273-0.475,0.057-0.475,0.057c-0.904-0.904-3.27-3.266-4.484-4.482C3.271,6.092,3.015,5.835,3.015,5.835
                        S2.067,6.78,1.474,7.374c-0.59,0.592-0.588-0.299-0.588-0.299S0.062,1.225,0.062,0.52C0.062,0.016,0.587,0.057,0.587,0.057z"/>
                      <path d="M23.122,23.608l-6.523-0.621c0,0-0.871,0.025-0.387-0.461c0.486-0.484,1.666-1.666,1.666-1.666
                        s-0.287-0.285-0.727-0.723c-1.256-1.26-3.541-3.543-4.471-4.479c0,0-0.322-0.18,0.062-0.564s2.07-2.07,2.346-2.344
                        c0.271-0.275,0.477-0.059,0.477-0.059c0.902,0.906,3.27,3.27,4.482,4.482c0.393,0.395,0.65,0.654,0.65,0.654
                        s0.949-0.947,1.541-1.541c0.59-0.592,0.59,0.301,0.59,0.301s0.822,5.854,0.822,6.549C23.651,23.647,23.122,23.608,23.122,23.608z"
                        />
                      <path d="M0.001,23.094l0.615-6.531c0,0-0.023-0.869,0.465-0.383c0.484,0.486,1.664,1.668,1.664,1.668
                        S3.03,17.561,3.47,17.12c1.256-1.256,3.541-3.541,4.475-4.475c0,0,0.184-0.316,0.568,0.066c0.383,0.387,2.07,2.072,2.344,2.346
                        c0.273,0.271,0.055,0.477,0.055,0.477c-0.906,0.904-3.266,3.27-4.48,4.486c-0.395,0.393-0.652,0.648-0.652,0.648
                        s0.945,0.947,1.537,1.537c0.592,0.594-0.297,0.59-0.297,0.59s-5.85,0.824-6.551,0.824C-0.042,23.62,0.001,23.094,0.001,23.094z"/>
                      <path d="M23.552,0.557l-0.615,6.529c0,0,0.023,0.869-0.461,0.383c-0.49-0.49-1.668-1.664-1.668-1.664
                        s-0.286,0.286-0.725,0.725c-1.256,1.256-3.543,3.541-4.475,4.473c0,0-0.184,0.318-0.568-0.066s-2.068-2.066-2.346-2.34
                        c-0.27-0.279-0.057-0.482-0.057-0.482c0.906-0.904,3.27-3.268,4.484-4.48c0.396-0.395,0.65-0.652,0.65-0.652
                        s-0.943-0.945-1.537-1.539c-0.592-0.592,0.299-0.586,0.299-0.586s5.849-0.828,6.552-0.828C23.595,0.03,23.552,0.557,23.552,0.557z"
                        />
                    </svg>
                  </button>
                  </span>
                </div>
                <v-img contain max-height="heighttest" v-bind:lazy-src="items[(page*3)-1].src" v-bind:src="items[(page*3)-1].src"></v-img>
              </div>
              <!-- Ligne 4-->
              <div class="col-md-12"><!--autoplay-->
                <audio style="width:100%" controls autoplay controlsList="nodownload"><source v-bind:src="musique" type="audio/mp3"> Votre navigateur 
                  n'est pas compatible</audio>
              </div>
            </div>
          </div>
          <!-- Modals -->
          <div class="modal fade" id="testImg1">
            <div class="modal-dialog modal-xl">
              <div class="modal-content titreColorImg">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel"  v-text="items[(page*3)-3].caption"></h5>
                  <button type="button"  data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>              
                </div>
                <div class="modal-body">
                   <v-img contain max-height="screen.height" max-width="screen.width" v-bind:lazy-src="items[(page*3)-3].src" v-bind:src="items[(page*3)-3].src"></v-img>
                </div>
              </div>
            </div>
          </div>  
          <div class="modal fade" id="testImg2">
            <div class="modal-dialog modal-xl">
              <div class="modal-content titreColorImg">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel" v-text="items[(page*3)-2].caption"></h5>
                  <button type="button" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>              
                </div>
                <div class="modal-body">
                  <v-img contain max-height="screen.height" max-width="screen.width" v-bind:lazy-src="items[(page*3)-2].src" v-bind:src="items[(page*3)-2].src"></v-img>
                </div>
              </div>
            </div>
          </div> 
          <div class="modal fade" id="testImg3">
            <div class="modal-dialog modal-xl">
              <div class="modal-content titreColorImg">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel" v-text="items[(page*3)-1].caption"></h5>
                  <button type="button" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>              
                </div>
                <div class="modal-body">
                  <v-img contain max-height="screen.height" max-width="screen.width" v-bind:lazy-src="items[(page*3)-1].src" v-bind:src="items[(page*3)-1].src"></v-img>
                </div>
              </div>
            </div>
          </div> 
        </v-app>
</template>

<script>
import Vuetify from 'vuetify';
import axios from 'axios';
import convert from 'xml-js';

export default {
  name: 'Galerie',
  vuetify: new Vuetify(),
  data:() =>{
    return{
      items:[ {src:'',thumbnail:'',caption: '',id:0},{src:'',thumbnail:'',caption: '',id:1},{src:'',thumbnail:'',caption: '',id:2}],
      cycle: false,
      heighttest:screen.height-550,
      currentId: null,
      play:true,
      pause:false,
      timer:null,
      taille:0,
      page: 1,
      pageSave:1,
      idimgclic:0,
      color05:"#3f3f3f",
      color1:"orange",
      color15:"#3f3f3f",
      color2:"#3f3f3f",
      time: 8,
      timeSave:8,
      defautTime:8,
      musique:"/inc/MortenLauridsen.mp3"
    }
  },
  methods:{  
    clikPause: function(){
      this.pause=true;
      this.play=false;
      clearInterval(this.timer);
      this.timer=null;
      if(this.timeSave!=this.time)
      {
        this.timeSave=this.time;
        this.clikPlay();
      }
    },
    autoplay:function()
    {
      var thisemplacement=this;
      if(!this.t){
        this.timer=setInterval(()=>{
          if((thisemplacement.pageSave==thisemplacement.page)
          &&(thisemplacement.timeSave==thisemplacement.time)
          &&((thisemplacement.page*3)!=thisemplacement.items.length)){
            thisemplacement.page++;
            thisemplacement.pageSave++;
          }
          else{
            thisemplacement.clikPause();
          }
        },thisemplacement.time * 1000);
      }
    },
    clikPlay:function(){
      this.pause=false;
      this.play=true;
      this.pageSave=this.page;
      this.autoplay();
    },
    change:function(nombre){
      this.color05="#3f3f3f";
      this.color1="#3f3f3f";
      this.color15="#3f3f3f";
      this.color2="#3f3f3f";
      switch (nombre) {
        case 0.5:
          this.color05="orange";
          break;
        case 1:
          this.color1="orange";
          break;
        case 1.5:
          this.color15="orange";
          break;
        case 2:
          this.color2="orange";
          break;
      }
      this.time=this.defautTime*nombre;
    },
  },
  beforeDestroy () {
    clearInterval(this.timer);
  },
  created: function(){
    this.autoplay();
  },
  async beforeMount(){
    const respgalerie = await axios.get('/inc/data-images.xml');
    var xmloptions = {compact: true, ignoreComment: true,alwaysChildren:true};
    var galeries = JSON.parse(convert.xml2json(respgalerie.data, xmloptions)).images.image;
    this.items = [ {
      src:'/galerie/images/'+galeries[1].lien._text,
      thumbnail:'/galerie/images/'+galeries[1].lien._text,
      caption: galeries[1].titre._text,
      id:0 
    }];
    for (var iterator=2;iterator<galeries.length;iterator++)
    {
      this.items.push({
        src:'/galerie/images/'+galeries[iterator].lien._text,
        thumbnail:'/galerie/images/'+galeries[iterator].lien._text,
        caption: galeries[iterator].titre._text,
        id:iterator-1
      });
    }
    for (iterator=1;iterator<=(this.items.length%3);iterator++)
    {
      this.items.push({
        src:'/galerie/images/'+galeries[iterator].lien._text,
        thumbnail:'/galerie/images/'+galeries[iterator].lien._text,
        caption: galeries[iterator].titre._text,
        id:this.items.length
      });
    }
    this.taille=Math.round(this.items.length/3);
  },
}
</script>

<style>
.theme--light.v-pagination .v-pagination__item--active {
  background-color:orange!important;
}
.titreColorImg{
  background-color: #3f3f3f!important;
  color: #d5d5d5!important;
}
.vitesse{
  font-size: 0.6rem;
  text-decoration: bold;
}
</style>